import { ContactPage } from "@components/pages/ContactPage"
import { SiteShell } from "@components/SiteShell"
import { contactPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"
import { getLocalizedCareers } from "@utils/siteData"

export const Route = createFileRoute("/$locale/contact/$slug")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: async ({ context, params }) => {
    const locale = params.locale as "en" | "ja"
    const data = await context.queryClient.ensureQueryData(contactPageQueryOptions(locale))
    const position = getLocalizedCareers(data, locale).find((item) => item.slug?.current === params.slug)
    if (!position) throw redirect({ href: `/${locale}/contact` })
    return { data, position }
  },
  head: ({ params, loaderData }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({
      locale,
      page: "contact",
      path: `/${locale}/contact/${params.slug}`,
      title: loaderData?.position?.title ? `${loaderData.position.title} | PLAYBRAIN Inc.` : undefined,
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const { data, position } = Route.useLoaderData()
  const labels = pageLabels(locale, "contact")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <ContactPage
        data={data}
        locale={locale}
        selectedPosition={position?.title ?? ""}
        isSubPage
      />
    </SiteShell>
  )
}
